import { z } from "zod";

/**
 * ReportMapaConcretagemColumnsSchema
 */

export const ReportMapaConcretagemColumnsSchema = z.object({
  dataConcretagem: z.boolean().default(false),
  tipoDoConcretoSolicitado: z.boolean().default(false),
  slumpSolicit: z.boolean().default(false),
  ensaioDoConcreto: z.boolean().default(false),
  resistMpa: z.boolean().default(false),
  moduloResistenciaGPA: z.boolean().default(false),
  ensaioModuloElasticidade: z.boolean().default(false),
  fornecedor: z.boolean().default(false),
  nroDoCarro: z.boolean().default(false),
  nroNotaFiscal: z.boolean().default(false),
  saidaUsina: z.boolean().default(false),
  entObra: z.boolean().default(false),
  inicioLanc: z.boolean().default(false),
  finalLanc: z.boolean().default(false),
  qtdeM3: z.boolean().default(false),
  slump: z.boolean().default(false),
  localDeLancamento: z.boolean().default(false),
  dataDeEnvioDaObra: z.boolean().default(false),
  laboratorio: z.boolean().default(false),
  nroCorpoDeProva: z.boolean().default(false),
  nroLote: z.boolean().default(false),
  nroLaudo: z.boolean().default(false),
  instrucaoDeRompimento: z.boolean().default(false),
  enviadoParaOLaboratorio: z.boolean().default(false),
  dataDeEnvioParaOLaboratorio: z.boolean().default(false),
  dozeHoras: z.boolean().default(false),
  dataDozeHoras: z.boolean().default(false),
  quatroDias: z.boolean().default(false),
  dataQuatroDias: z.boolean().default(false),
  seteDias: z.boolean().default(false),
  dataSeteDias: z.boolean().default(false),
  quatorzeDias: z.boolean().default(false),
  dataQuatorzeDias: z.boolean().default(false),
  vinteUmDias: z.boolean().default(false),
  dataVinteUmDias: z.boolean().default(false),
  vinteOitoDias: z.boolean().default(false),
  dataVinteOitoDias: z.boolean().default(false),
  cinquentaSeisDias: z.boolean().default(false),
  dataCinquentaSeisDias: z.boolean().default(false),
  sessentaTresDias: z.boolean().default(false),
  dataSessentaTresDias: z.boolean().default(false),
  elasticidade28: z.boolean().default(false),
  dataElasticidade28: z.boolean().default(false),
  outrasIdades1: z.boolean().default(false),
  dataOutrasIdades1: z.boolean().default(false),
  outrasIdades2: z.boolean().default(false),
  dataOutrasIdades2: z.boolean().default(false),
  outrasIdades3: z.boolean().default(false),
  dataOutrasIdades3: z.boolean().default(false),
  aprovado: z.boolean().default(false),
  responsavelPelaAprovacao: z.boolean().default(false),
  dataDaAprovacao: z.boolean().default(false),
  observacao: z.boolean().default(false),
});

/**
 * ReportMapaConcretagemSchema
 */

export const ReportMapaConcretagemSchema = z.object({
  dataInicio: z.coerce.date().nullable().default(null),
  dataFim: z.coerce.date().nullable().default(null),
  fornecedores: z.array(z.number()).nullable().default(null),
  localLancamento: z.string().nullable().default(null),
  resistencia: z.string().nullable().default(null),
  nroNotaFiscal: z.string().nullable().default(null),
  statusRompimento: z.coerce.number().default(1),
  enviadoLaboratorio: z.coerce.number().default(1),
  colunas: ReportMapaConcretagemColumnsSchema,
});

/**
 * ReportMapaConcretagemForm
 */

export type ReportMapaConcretagemForm = z.infer<typeof ReportMapaConcretagemSchema>;

/**
 * ReportMapaConcretagemColumnsForm
 */

export type ReportMapaConcretagemColumnsForm = z.infer<typeof ReportMapaConcretagemColumnsSchema>;

/**
 * initialReportMapaConcretagem
 */

export const initialReportMapaConcretagem: Partial<ReportMapaConcretagemForm> = {
  statusRompimento: 2,
  enviadoLaboratorio: 2,
  colunas: {
    dataConcretagem: false,
    tipoDoConcretoSolicitado: false,
    slumpSolicit: false,
    ensaioDoConcreto: false,
    resistMpa: false,
    moduloResistenciaGPA: false,
    ensaioModuloElasticidade: false,
    fornecedor: false,
    nroDoCarro: false,
    nroNotaFiscal: false,
    saidaUsina: false,
    entObra: false,
    inicioLanc: false,
    finalLanc: false,
    qtdeM3: false,
    slump: false,
    localDeLancamento: false,
    dataDeEnvioDaObra: false,
    laboratorio: false,
    nroCorpoDeProva: false,
    nroLote: false,
    nroLaudo: false,
    instrucaoDeRompimento: false,
    enviadoParaOLaboratorio: false,
    dataDeEnvioParaOLaboratorio: false,
    dozeHoras: false,
    dataDozeHoras: false,
    quatroDias: false,
    dataQuatroDias: false,
    seteDias: false,
    dataSeteDias: false,
    quatorzeDias: false,
    dataQuatorzeDias: false,
    vinteUmDias: false,
    dataVinteUmDias: false,
    vinteOitoDias: false,
    dataVinteOitoDias: false,
    cinquentaSeisDias: false,
    dataCinquentaSeisDias: false,
    sessentaTresDias: false,
    dataSessentaTresDias: false,
    elasticidade28: false,
    dataElasticidade28: false,
    outrasIdades1: false,
    dataOutrasIdades1: false,
    outrasIdades2: false,
    dataOutrasIdades2: false,
    outrasIdades3: false,
    dataOutrasIdades3: false,
    aprovado: false,
    responsavelPelaAprovacao: false,
    dataDaAprovacao: false,
    observacao: false,
  },
};